import moment from 'moment';
import OrderTable from "../components/module/admin/OrderTable";
import AdminFilter from "../components/module/admin/AdminFilter";
import {SweetModal} from 'sweet-modal-vue'
import LpModal from '../components/module/common/LpModal.vue'
import AdminSimpleTable from '../components/module/admin/AdminSimpleTable';
import Structure from '../helper/structure-ship-agency'
import Const from '../utils/const.js'

export default {

  components: {
    AdminFilter,
    OrderTable,
    SweetModal,
    LpModal,
    AdminSimpleTable
  },

  created() {
    // tableData, filter_list 초기화
  },

  data() {
    return {
      tableData: [],
      filterData: [],
      filtered: {},
      filter_list: [],
      allCount: 0,
      filteredCount: 0,
      tableItems: [],
      structure_path:'',
      post_url:'',
      // 체크리스트
      checkArr: [],
      // 요청할 상태
      status: 0,
      // 변경할 상태값 목록
      status_arr: [],
      selectedSingleItem: 0,  // 선택된 단일 항목 id
      optionState: undefined,  // 일괄처리 all 단일버튼 btn
    }
  },
  watch: {
    modalStatus(n) {
      if(n==='close' && this.post_url){
        this.getData(this.post_url);
      }
    }
  },
  computed: {
    path() {
      return this.$route.path.replace('/office/admin/','');
    }
  },

  methods: {
    // 체크박스 일괄 선택
    clickCheckBox(res) {
      this.checkArr.forEach(i => i.value = res);
    },
    // structre_path : 필터 데이터, 테이블 데이터
    // post_url : axios 호출할 post url
    initializing(structure_path, post_url, init_status=0) {
      this.structure_path = structure_path;
      this.post_url = post_url;
      this.setStructure(structure_path);
      this.initFiltered();
      if(init_status>0) {
        this.filtered.status = init_status;
      }
      this.getData();
      this.getStatusList();
    },
    setStructure(structure_path) {
      this.filterData = Structure[structure_path+'_filter_data'];
      // 전체 현황에서만 상태 필터링 추가
      if(this.$route.path.indexOf('order_list_all')===-1) {
        this.filterData = this.filterData.filter(i => i.key !== 'status');
      }
      this.tableData = Structure[structure_path+'_table_data'];
      // 입금대기목록에서 파일 필드 추가
      let fileIndex = this.tableData.findIndex(i => i.eng_name === 'file');
      if(this.$route.path.indexOf('order_list_pay_req')>-1) {
        if(fileIndex===-1) {
          this.tableData.splice(
            this.tableData.findIndex(i => i.eng_name === 'invoice_num') + 1, 0,
            {
              eng_name: 'file',
              ko_name: '인보이스 파일',
              ordering: false,
              width: '120px'
            }
          )
        }
      } else {
        if(fileIndex>-1) {
          this.tableData.splice(fileIndex, 1);
        }
      }

    },
    initFiltered() {
      this.filtered = {
        cur_page: 1,
        page_num:1,
        total_page:1,
        page_length: 10
      };
    },

    // 내역 가져오기
    getData() {
      if(!this.post_url) return;
      this.$axios.get(this.getUrl(this.post_url), {
        params: this.filtered
      })
        .then(res => {
          if ( res.status === 200 ) {
            if ( res.data.data === undefined )
              this.tableItems = res.data;
            else
              this.tableItems = res.data.data;
            this.filtered.page_length = res.data.page_length;
            this.filtered.cur_page = res.data.cur_page;
            this.filtered.total_page = res.data.total_page;
            this.allCount = res.data.total_count;
            this.filteredCount = res.data.count;

            this.checkArr = this.tableItems.map(i => {
              return {
                id: i.id,
                value: false
              }
            });
            /* 테이블에 재조합 rowspan 추가 */
            this.initDeliveryTable();
          }
        }).catch(res => {});
    },

    selPageLength(length) {
      this.filtered.page_length = length;
      this.filtered.page_num = 1;
      this.getData();
    },

    ordering(res){
      this.filtered.ordering=res;
      this.getData();
    },

    // 상태값 목록
    getStatusList(){
      this.$axios.get(this.getUrl(`shipagency/order/status`)).then(res=>{
        if(res.status === 200){
          this.status_arr = res.data;
        }
      })
    },

    saveData (modal_name) {
      let id_list = this.getCheckedArr();
      if(id_list.length === 0) return;

      this.$axios.post(this.getUrl('shipagency/order/status/change/multiple'),{
        status: this.status,
        checked: id_list,
      }).then(res=>{
        if(res.status===200){
          this.toast('상태가 변경되었습니다.');
          this.getData();
        }
      })
    },

    // 일괄 상태 변경
    clickChange(){
      if(confirm('상태를 변경하시겠습니까?')) {
        this.saveData();
      }
    },

    //  체크된 id들 가져오기
    getCheckedArr(){
      return this.checkArr.filter(i => i.value).map(i => i.id);
    }
  }
}
